var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalproapt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_19761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2788 88L0 70.6884V13.6863L44.7532 28.2362L44.2788 88Z",
    fill: "#0870B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M43.1627 0L0.00585938 13.698L44.5835 28.3567L88.9996 13.6902L43.1627 0Z",
    fill: "#F59F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 35.5934V20.646L38.554 30.7296V45.9696L4.8916 35.5934Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5361 37.5022V33.215L38.554 31.2513V35.5112L22.5361 37.5022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.8916 35.1889V30.5574L20.0972 28.1541V32.9819L4.8916 35.1896V35.1889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 55.8896V38.0428L38.1187 49.0316V67.1827L4.8916 55.8896Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 68.5901V51.7307L38.0102 63.6528V80.7994L4.8916 68.5901Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6013 51.4016L42.7161 65.4071L42.1519 67.0369L2.03711 53.0314L2.6013 51.4016Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4972 76.0249L20.001 21.761L22.4063 21.7388L22.9025 76.0027L20.4972 76.0249Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2266 87.9601L88.9797 70.6884V13.6863L44.6385 28.1815L44.2266 87.9601Z",
    fill: "#0870B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2694 54.4853L44.7632 69.176L43.9805 66.8918L86.4866 52.201L87.2694 54.4853Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0781 76.0027L66.5743 21.7388L68.9796 21.761L68.4834 76.0249L66.0781 76.0027Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1097 36.4751V21.5277L49.4473 31.6113V46.8513L83.1097 36.4751Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1097 52.8502V37.9028L49.4473 47.9864V63.2264L83.1097 52.8502Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9642 53.3013L45.8494 67.3075L45.2852 65.6777L85.4 51.6715L85.9642 53.3013Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0996 76.8851L65.5958 22.6212L68.0011 22.6434L67.5049 76.9073L65.0996 76.8851Z",
    fill: "#006FBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5166 82.0057L77.2454 75.2298L77.5708 56.7822L59.6352 62.3235L59.5174 82.0057H59.5166Z",
    fill: "#223B7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0027 67.7132C78.179 68.0507 78.0495 68.4679 77.7134 68.645L75.2518 69.9421C74.9157 70.1192 74.5003 69.9892 74.3239 69.6516C74.1476 69.3141 74.2771 68.8969 74.6132 68.7198L77.0748 67.4227C77.4109 67.2456 77.8263 67.3756 78.0027 67.7132Z",
    fill: "#006FBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_19761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalproapt);
export default __webpack_public_path__ + "static/media/localproapt.955655c5efc803c936272120e90c19e9.svg";
export { ForwardRef as ReactComponent };